<template>
    <div v-if="!useBuefyTooltip"
        :style="noUnderline ? '' : 'border-bottom: 1px dashed #B5B5B5'"
        class="cursor-default"
        :title="label"
    >
        <!-- @slot Default slot for tooltip content -->
        <slot></slot>
    </div>
    <div v-else class="b-wrap">
        <b-tooltip v-if="useBuefyTooltip"
            v-bind="$props"
            type="is-white"
            :class="{
                'allow-line-breaks': allowLineBreaks,
                'is-small': isSmall
            }"
        >
            <!-- @slot Default slot for tooltip content -->
            <slot></slot>
            <!-- @slot Content slot for complex tooltip content -->
            <template #content>
                <slot name="content"></slot>
            </template>
        </b-tooltip>
    </div>
</template>
<script>
export default {
    props: {
        /**
        * Sets white-space to "pre" in the tooltip content
        */
        allowLineBreaks:Boolean,
        /**
        * Sets font size to 12px
        */
        isSmall: Boolean,
        /*
        * removes the dashed line underneath the the tooltip content
        */
        noUnderline: Boolean,
        /**
        * By default the "title" tag is used. Set this to true to use the Buefy tooltip component
        */
        useBuefyTooltip: Boolean,
        /*
            Buefy component props.
            Props that are not used or unlikely to be used are commented out intentionally
            https://github.com/buefy/buefy/blob/dev/src/components/tooltip/Tooltip.vue
        */
        // active: {
        //     type: Boolean,
        //     default: true
        // },
        // type: {
        //     type: String,
        //     default: () => config.defaultTooltipType
        // },
        /**
        * The text of the tooltip
        */
        label: String,
        /**
        * @ignore Unused prop
        */
        delay: {
            type: Number,
            default: () => 100
        },
        /**
        * The placement of the tooltip from the hover element
        */
        position: {
            type: String,
            default: 'is-top',
            validator(value) {
                return [
                    'is-top',
                    'is-bottom',
                    'is-left',
                    'is-right'
                ].indexOf(value) > -1;
            }
        },
        /**
        * @ignore Unused prop
        */
        triggers: {
            type: Array,
            default: () => ['hover']
        },
        // always: Boolean,
        /**
        * @ignore Unused prop
        */
        dashed: Boolean,
        /**
        * @ignore Unused prop
        */
        multilined: {
            type: Boolean,
            default: true // defaulted to true
        },
        /**
        * @ignore Unused prop
        */
        size: {
            type: String,
            default: 'is-medium'
        },
        /**
        * @ignore Unused prop
        */
        appendToBody: {
            type: Boolean,
            default: true // changed default to true
        },
        /**
        * @ignore Unused prop
        */
        animated: {
            type: Boolean,
            default: true
        },
        /**
        * @ignore Unused prop
        */
        animation: {
            type: String,
            default: 'fade'
        },
        /**
        * @ignore Unused prop
        */
        autoClose: {
            type: [Array, Boolean],
            default: true
        }
    }
};
</script>
<style>
</style>